import { getDeepProperty } from '@/helpers/deepObject.js'

export default {
  setup (pendoClient, user, currentAccount, activePodcast, podcastCount) {
    const permission = getDeepProperty(currentAccount, 'permission') || []
    let permissionList = []
    Object.keys(permission).map((key) => {
      if (permission[key] === true) {
        permissionList.push(key)
      } else if (key === 'app_key') {
        permissionList.push(permission.app_key)
      }
    })
    pendoClient.initialize({
      visitor: {
        id: user.id,
        name: user.name,
        email: user.email,
        roles: permissionList,
        created_at: user.created_at,
        podcast_count: podcastCount
      },
      account: {
        id: currentAccount.id,
        name: currentAccount.name,
        created_at: currentAccount.created_at,
        plan: getDeepProperty(activePodcast, 'plan.name'),
        is_delinquent: getDeepProperty(activePodcast, 'is_delinquent'),
        owner_name: getDeepProperty(currentAccount, 'owner.name'),
        owner_email: getDeepProperty(currentAccount, 'owner.email'),
        has_adswizz_enabled: getDeepProperty(currentAccount, 'features.has_calisto') !== undefined,
        has_ad_creatives: getDeepProperty(currentAccount, 'features.has_ad_creatives') !== undefined,
        has_ad_quality_enabled: getDeepProperty(activePodcast, 'blocked_domains.href') !== undefined
      }
    })
  }
}
